export type BootMode = 'prod-discord' | 'dev-real' | 'dev-mock';

export interface BootEnv {
  DEV: boolean;
  MODE: string;
}

export function pickBootMode(env: BootEnv, url: URL): BootMode {
  if (!env.DEV) return 'prod-discord';
  if (url.searchParams.get('mock') === '1') return 'dev-mock';
  if (env.MODE === 'mock') return 'dev-mock';
  return 'dev-real';
}
